import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';
import { uploadAxiosConfig, resolveOnUploadProgress, resolveUploadSignal } from '../utils/upload-axios-config.js';

export class MeetingApi extends BaseApi {
    constructor(client) {
        super(client, '/meeting');
    }

    async getReviewInputs(id) {
        const response = await this.client.get(`${this.basePath}/${id}/review-inputs`);
        return response.data;
    }

    /**
     * @param {File|Blob} file
     * @param {Function|{ onUploadProgress?: Function, signal?: AbortSignal }} [optionsOrCallback]
     */
    async uploadYggReport(file, optionsOrCallback) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            const response = await this.client.post(
                `${this.basePath}/upload-ygg-report`,
                formData,
                uploadAxiosConfig({
                    onUploadProgress: resolveOnUploadProgress(optionsOrCallback),
                    signal: resolveUploadSignal(optionsOrCallback),
                    headers: { 'Content-Type': 'multipart/form-data' },
                }),
            );
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * @param {{ storageKey?: string, url?: string }} body
     */
    async discardUploadedYggReport(body) {
        try {
            const response = await this.client.delete(`${this.basePath}/uploaded-ygg-report`, { data: body });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
